import React, { Component } from "react";
import { StyleSheet, View, TextInput, Text, TouchableOpacity } from "react-native";
import { connect } from "react-redux";
import NewIssue from "../dialogs/newIssue";
import { searchItems } from "../../actions/records";
import { getMyCustomers, getMySuppliers } from "../../actions/submissions";
import DropDownLocations from "../widgets/dropdownLocations";
import colors from "../../constants/colors";
import { MaterialCommunityIcons } from "@expo/vector-icons";
var _interval = null;
class SearchInventoryLocations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.defaultLabel == "toLocation" ? this.renderLocation(props.initial) : typeof props.initial == "string" ? props.initial : "",
            locationSelected: props.initial && typeof props.initial == "object" ? props.initial : [],
            height: 30,
            items: props.options ? props.options : [],
            filtered: props.options ? props.options : [],
            wasEdited: false,
            openList: false,
        };
    }
    componentDidMount() {
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps?.options != this.props.options) {
            this.setState({ items: nextProps.options, filtered: nextProps.options, });
        }
        if (nextProps?.initial != this.props.initial && typeof nextProps?.initial == "object") {
            this.setState({ locationSelected: nextProps?.initial });
        }
        if (nextProps?.initial != this.props.initial && typeof nextProps?.initial == "string") {
            this.setState({ value: nextProps?.initial });
        }
        if (nextProps.closeSearch != this.props.closeSearch) {
            this.setState({ filtered: [], wasEdited: false });
        }
    }
    searchItems(val, focused) {
        const { items } = this.state;
        var search = val;
        if(_interval)clearInterval(_interval);
        if (search) {
            search = search.toLowerCase().trim();
            var filtered = items.filter((item) => {
                var completeLocation = "";
                if (item?.site?.locationName) {
                    completeLocation += item.site.locationName;
                }
                if (item?.zone?.locationName) {
                    completeLocation += "-" + item.zone.locationName;
                }
                if (item?.aisle?.locationName) {
                    completeLocation += "-" + item.aisle.locationName;
                }
                if (item?.rackBay?.locationName) {
                    completeLocation += "-" + item.rackBay.locationName;
                }
                if (item?.shelfLevel?.locationName) {
                    completeLocation += "-" + item.shelfLevel.locationName;
                }
                if (item?.bin?.locationName) {
                    completeLocation += "-" + item.bin.locationName;
                }
                completeLocation = completeLocation.toLowerCase().trim();
                console.log(completeLocation + " - " + search);
                return completeLocation.includes(search);
            });
            this.setState({ filtered: filtered, openList: true });
        } else {
            this.setState({ filtered: items, wasEdited: focused ? true : false });
        }
    }
    renderLocation(location) {
        var item = location;
        if (typeof item == "object" && item?.length > 0) {
            item = item[0];
        } else if (typeof item == "string") {
            return item;
        }
        var completeLocation = "";
        if (item?.site?.locationName) {
            completeLocation += item.site.locationName;
        }
        if (item?.zone?.locationName) {
            completeLocation += "-" + item.zone.locationName;
        }
        if (item?.aisle?.locationName) {
            completeLocation += "-" + item.aisle.locationName;
        }
        if (item?.rackBay?.locationName) {
            completeLocation += "-" + item.rackBay.locationName;
        }
        if (item?.shelfLevel?.locationName) {
            completeLocation += "-" + item.shelfLevel.locationName;
        }
        if (item?.bin?.locationName) {
            completeLocation += "-" + item.bin.locationName;
        }
        return completeLocation;
    }
    render() {
        const { value, items, wasEdited, filtered, openList } = this.state;
        const { defaultComponent, onSelectItem, placeholder, customers, isShipmentLog, suppliers, width, isRecipe, openDropDown, backgroundColor, isLast, defaultLabel, isDropDownOpened, resetDropDown } = this.props;
        return <View>
            <TextInput
                value={value}
                editable={!defaultComponent}
                onFocus={() => {
                    if(!defaultComponent)this.searchItems("", true);
                }}
                onContentSizeChange={(event) => {
                    if (event.nativeEvent.contentSize.height == 0) {
                        if (this.props.placeholder == '') {
                            this.setState({ height: 30 })
                        }
                        this.setState({ height: event.nativeEvent.contentSize.height });
                    } else {
                        setTimeout(() => {
                            this.setState({ height: event.nativeEvent.contentSize.height });
                        }, 5)
                    }
                }}
                style={styles.input, {
                    borderColor: "#e7e7e7",
                    borderRadius: 5,
                    borderWidth: 1,
                    color: "#424242",
                    fontFamily: "Roboto",
                    fontSize: 20,
                    fontWeight: "400",
                    padding: 5,
                    height: this.state.height,
                    fontStyle: this.state.value ? this.state.value.length == 0 ? 'italic' : 'normal' : 'normal',
                    overflow: 'hidden'
                }}
                multiline={true}
                placeholder={placeholder}
                placeholderTextColor={'rgb(0, 47, 108)'}
                onChangeText={(val) => {
                    if (val == '' && this.props.placeholder == '') {
                        this.setState({ value: val, height: 30, wasEdited: true });

                    } else {
                        this.setState({ value: val, wasEdited: true });
                    }
                    if(_interval)clearInterval(_interval);
                    _interval = setInterval(() => this.searchItems(val, false), 500);
                    onSelectItem(val);
                }}
            />
            {
                items?.length > 0 && defaultLabel != "toLocation" &&
                <DropDownLocations
                    initialOption={this.state.locationSelected}
                    updated={this.state.locationSelected}
                    options={filtered}
                    defaultComponent={defaultComponent}
                    openList={openList}
                    allLabel={"All Locations"}
                    onSelect={(option) => {
                        onSelectItem(option)
                    }}
                    width={width}
                    isRecipe={isRecipe}
                    openDropDown={openDropDown}
                    backgroundColor={backgroundColor}
                    isLast={isLast}
                    isDropDownOpened={isDropDownOpened}
                    resetDropDown={resetDropDown}
                />
            }
            {
                filtered?.length > 0 && defaultLabel == "toLocation" && wasEdited &&
                filtered.map((item, idx) => {
                    return <div key={idx} style={{ ...styles.row, gridTemplateColumns: customers ? "95% 5%" : width == "mini" ? "80% 20%" : "90% 10%" }}>
                        <div>
                            {this.renderLocation(item)}
                        </div>
                        <div>
                            <TouchableOpacity style={styles.rowBtn} onPress={() => {
                                onSelectItem([item]);
                                this.setState({ value: this.renderLocation(item), wasEdited: false })
                            }}><Text>
                                    <MaterialCommunityIcons name="plus" style={styles.selectOption} />
                                </Text>
                            </TouchableOpacity>
                        </div>

                    </div>
                })
            }
            {
                (value && filtered?.length <= 0 && wasEdited) ? <View>
                    <Text>No locations were found</Text>
                </View> : null
            }
        </View>
    }
}

export default connect((state, ownProps = {}) => ({
    isLoading: state.forms.getIn(["form", "status"]) === "loading",
    company_id: state.user.get("company_id"),
}), (dispatch, props) => ({
    searchItems: (formid, saveAsTemplate, saveAsForm, callback) =>
        dispatch(searchItems(formid, saveAsTemplate, saveAsForm, callback)),
    getMyCustomers: (data, callback) =>
        dispatch(getMyCustomers(data, callback)),
    getMySuppliers: (id, page, filter, callback) =>
        dispatch(getMySuppliers(id, page, filter, callback)),
}))(SearchInventoryLocations);

const styles = StyleSheet.create({
    container: {
        flexDirection: "column",
        paddingTop: 5,
        flex: 1,
    },
    input: {
        borderColor: "#e7e7e7",
        borderRadius: 5,
        borderWidth: 1,
        color: "#424242",
        fontFamily: "Roboto",
        fontSize: 22,
        fontWeight: "400",
        paddingLeft: 10,
    },
    label: {
        fontSize: 20,
        color: '#939598',
        fontWeight: '300',
        fontFamily: 'Roboto',

    },
    row: {
        display: "grid",
        width: "100%",
        fontFamily: "Roboto",
        fontSize: 18
    },
    rowBtn: {
        color: colors.selectSearch,
        border: '2px solid',
        borderRadius: 4,
        cursor: 'pointer'
    },
    selectOption: {
        fontSize: 20,
        color: colors.selectSearch
    }
});